var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.50387C0 5.36756 0.642006 4.32877 1.65836 3.82059L8.65836 0.320589C10.6531 -0.676762 13 0.773723 13 3.00387V4.76781H15C16.6569 4.76781 18 6.11095 18 7.76781V21C18 22.6569 16.6569 24 15 24H3C1.34315 24 0 22.6569 0 21V6.50387ZM9.55279 2.10944C10.2177 1.77699 11 2.26049 11 3.00387V4.76781H4.23606L9.55279 2.10944ZM2 7.76781C2 7.21552 2.44772 6.76781 3 6.76781H15C15.5523 6.76781 16 7.21552 16 7.76781V21C16 21.5523 15.5523 22 15 22H3C2.44772 22 2 21.5523 2 21V7.76781Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16.7678C4 16.2155 4.44772 15.7678 5 15.7678H13C13.5523 15.7678 14 16.2155 14 16.7678V18.7678C14 19.3201 13.5523 19.7678 13 19.7678H5C4.44772 19.7678 4 19.3201 4 18.7678V16.7678Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.7678C4 9.21552 4.44772 8.7678 5 8.7678H13C13.5523 8.7678 14 9.21552 14 9.7678C14 10.3201 13.5523 10.7678 13 10.7678H5C4.44772 10.7678 4 10.3201 4 9.7678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.82180f9e0fd0180ece253716a0e40d74.svg";
export { ForwardRef as ReactComponent };